<div class="floating-block"></div>

<div class="wrapper" [ngStyle]="wrapperStyles">
  <div class="parent">
    <img class="stars" src="assets/images/games/speed-reading/stars.png" />
    <div class="content">
      <div [ngStyle]="{ display: figuresRef.children.length ? 'block' : 'none' }" class="figures-wrapper">
        <div class="figures" #figuresRef>
          <ng-content
            select="ms-speed-reading-result-figure, [ms-speed-reading-result-figure], ms-speed-reading-result-questions, [ms-speed-reading-result-questions]"
          ></ng-content>
        </div>
      </div>
      <div [ngStyle]="{ display: rowsRef.children.length ? 'block' : 'none' }" class="rows-wrapper">
        <div class="rows" #rowsRef>
          <ng-content
            select="ms-speed-reading-result-row, [ms-speed-reading-result-row]"
          ></ng-content>
        </div>
      </div>
      <div class="text">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
